<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol *ngIf="!showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Payment Methods</span></li>
                    </ol>
                    <ol *ngIf="showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a (click)="returnToList()" style="cursor: pointer;">Payment Methods</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>{{ detailViewed!.title }}</span></li>
                    </ol>
                </div>
                <div class="content-title">
                    <h2>Payment Methods</h2>
                </div>
                <hr>

                <!-- LIST -->
                <div class="list-holder" *ngIf="!showDetails">
                    <div class="tools">
                        <div class="search mg-right-auto">
                            <span class="pm-hint">
                                Methods are switched off rather than deleted — past bookings still reference them.
                            </span>
                        </div>
                        <div class="actions">
                            <button class="btn btn-sm btn-default" *ngIf="canManage" (click)="openAdd(addModal)">Add Payment Method</button>
                        </div>
                    </div>
                    <div class="list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Category</th>
                                    <th>Gateway</th>
                                    <th>Type</th>
                                    <th>Express</th>
                                    <th>TNVS</th>
                                    <th>Taxi</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="methods.length !== 0; else noRecords">
                                    <tr *ngFor="let method of methods">
                                        <td>{{ method.title }}</td>
                                        <td>{{ method.category }}</td>
                                        <td>{{ method.gateway }}</td>
                                        <td><code class="pm-code">{{ method.type }}</code></td>
                                        <td>{{ method.allowExpress ? 'Yes' : 'No' }}</td>
                                        <td>{{ method.allowTnvs ? 'Yes' : 'No' }}</td>
                                        <td>{{ method.allowTaxi ? 'Yes' : 'No' }}</td>
                                        <td>
                                            <span class="stat" [ngClass]="method.isActive ? 'pm-on' : 'pm-off'">
                                                {{ method.isActive ? 'Active' : 'Inactive' }}
                                            </span>
                                        </td>
                                        <td><a (click)="viewDetails(method)" style="cursor: pointer;">View</a></td>
                                    </tr>
                                </ng-container>
                                <ng-template #noRecords>
                                    <tr>
                                        <td colspan="9" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold" *ngIf="isLoading">Loading…</h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'unsupported'">
                                                Not available on this environment yet.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'failed'">
                                                Connection not available. Please try again.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'none'">
                                                No records found
                                            </h6>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- DETAIL / EDIT -->
                <div class="list-holder" *ngIf="showDetails && detailViewed">
                    <div class="tools">
                        <div class="search mg-right-auto"></div>
                        <div class="profile-actions">
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                (click)="enableEditForm()" *ngIf="!enableEdit && canManage">Edit Details</button>
                            <button class="btn btn-sm btn-default" style="min-width: 100px;" [disabled]="isSaving"
                                (click)="confirmUpdate(confirmUpdateModal)" *ngIf="enableEdit">Save</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;" [disabled]="isSaving"
                                (click)="disableEditForm()" *ngIf="enableEdit">Cancel</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;"
                                (click)="returnToList()" *ngIf="!enableEdit">Back to List</button>
                        </div>
                    </div>

                    <div class="panel">
                        <div class="panel-info">
                            <ng-container
                                *ngTemplateOutlet="methodFields; context: { f: form, editable: enableEdit }">
                            </ng-container>

                            <div class="form-item">
                                <label class="form-label">Last Updated</label>
                                <input type="text" class="form-control"
                                    [value]="(detailViewed.dateUpdated | date:'MM-dd-yyyy h:mm a') || ''"
                                    disabled="true">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Shared field set, used by both the edit panel and the add modal. -->
<ng-template #methodFields let-f="f" let-editable="editable">
    <div class="form-item">
        <label class="form-label">Title</label>
        <input type="text" class="form-control" maxlength="50" placeholder="e.g. GCash"
            [(ngModel)]="f.title" [disabled]="!editable">
    </div>

    <div class="form-item">
        <label class="form-label">Description</label>
        <input type="text" class="form-control" maxlength="200"
            placeholder="Shown under the title in the app's picker"
            [(ngModel)]="f.description" [disabled]="!editable">
    </div>

    <div class="form-item">
        <label class="form-label">Icon</label>
        <input type="text" class="form-control" placeholder="Icon URL"
            [(ngModel)]="f.icon" [disabled]="!editable">
        <div class="pm-icon-preview" *ngIf="f.icon">
            <img [src]="f.icon" alt="" onerror="this.style.display='none'">
        </div>
    </div>

    <div class="form-item">
        <label class="form-label">Category</label>
        <select class="form-select" [(ngModel)]="f.category" [disabled]="!editable">
            <option *ngFor="let c of categories" [value]="c.value">{{ c.label }}</option>
        </select>
        <small class="pm-hint">Cash settles the service fee from the partner's top-up balance.</small>
    </div>

    <div class="form-item">
        <label class="form-label">Gateway</label>
        <select class="form-select" [(ngModel)]="f.gateway" [disabled]="!editable">
            <option *ngFor="let g of gateways" [value]="g.value">{{ g.label }}</option>
        </select>
    </div>

    <div class="form-item">
        <label class="form-label">Type</label>
        <select class="form-select" [(ngModel)]="f.type" [disabled]="!editable">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
        </select>
        <small class="pm-hint">
            A behaviour key, not a label — it decides how the payment is actually processed, so it is
            picked from this list rather than typed.
        </small>
    </div>

    <div class="pm-warning" *ngIf="editable && mismatchWarning(f)">
        <i class="fa fa-exclamation-triangle"></i>
        <span>{{ mismatchWarning(f) }}</span>
    </div>

    <div class="form-item">
        <label class="form-label">Status</label>
        <select class="form-select" [(ngModel)]="f.isActive" [disabled]="!editable">
            <option [ngValue]="true">Active — offered in the apps</option>
            <option [ngValue]="false">Inactive — hidden everywhere</option>
        </select>
    </div>

    <div class="form-item">
        <label class="form-label">Available for</label>
        <div class="pm-flags">
            <label><input type="checkbox" [(ngModel)]="f.allowExpress" [disabled]="!editable"> OK! Express</label>
            <label><input type="checkbox" [(ngModel)]="f.allowTnvs" [disabled]="!editable"> OK! Ride / MotoTaxi</label>
            <label><input type="checkbox" [(ngModel)]="f.allowTaxi" [disabled]="!editable"> OK! Taxi</label>
            <label><input type="checkbox" [(ngModel)]="f.allowFood" [disabled]="!editable"> Food</label>
            <label><input type="checkbox" [(ngModel)]="f.allowGrocery" [disabled]="!editable"> Grocery</label>
        </div>
        <small class="pm-hint">OK! Taxi is metered and settles in cash, so e-wallets are normally off for it.</small>
    </div>
</ng-template>

<ng-template #addModal let-modal class="modal">
    <div class="modal-header">
        <h4>Add Payment Method</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="panel-info">
            <ng-container *ngTemplateOutlet="methodFields; context: { f: addForm, editable: true }"></ng-container>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving"
            (click)="createMethod(successAddModal)">Create</button>
    </div>
</ng-template>

<ng-template #confirmUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>Save changes to <strong>{{ detailViewed!.title }}</strong>?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving"
            (click)="updateMethod(successUpdateModal)">Yes, Update</button>
    </div>
</ng-template>

<ng-template #successAddModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body success-body">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Payment method successfully created</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>

<ng-template #successUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body success-body">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Payment method successfully updated</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>
